import {Button, css, Stack, styled, Typography} from '@mui/material';
import {ProductEnum} from 'presentation/constants';

const StyledContainer = styled(Stack)`
	width: 100%;
	height: 100%;
	max-height: 144px;
	flex-direction: row;
	background-color: ${({theme}) => theme.palette.background.paper};
	border-radius: 8px;
	overflow: hidden;

	${({theme}) => theme.breakpoints.up('lg')} {
		max-height: 137px;
	}

	${({theme}) =>
		theme.name === ProductEnum.NOTREDAME_SAUDE &&
		css`
			border: 1px solid #e9eaeb;
		`}
`;

const StyledImage = styled('img')`
	width: 98px;
	object-fit: cover;

	${({theme}) => theme.breakpoints.between('lg', 'xl')} {
		width: 80px;
	}
`;

const StyledContent = styled(Stack)`
	justify-content: space-between;
	width: 100%;
	min-width: 202px;
	height: 100%;
	padding: 8px 16px;
	gap: 8px;

	${({theme}) => theme.breakpoints.between('lg', 'xl')} {
		min-width: 0;
		padding: 8px 12px;
		gap: 6px;
	}
`;

const StyledTitle = styled(Typography)`
	overflow: hidden;
	color: ${({theme}) => theme.palette.text.primary};
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;

	font-size: 16px;
	font-weight: 600;
	line-height: 120%;
	letter-spacing: 0.15px;
`;

const StyledDescription = styled(Typography)`
	flex: 1;
	overflow: hidden;
	max-height: 40px;
	color: ${({theme}) => theme.palette.text.primary};
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;

	font-size: 14px;
	font-weight: 400;
	line-height: 143%;
	letter-spacing: 0.17px;
`;

const StyledButton = styled(Button)`
	align-self: flex-end;
`;

export {StyledButton, StyledContainer, StyledContent, StyledDescription, StyledImage, StyledTitle};
